<template>
	<v-app-bar v-if="!loggedIn" app dense color="primary">
		<v-toolbar-title class="headline">
			<router-link to="/" style="text-decoration: none" class="white--text">
				<span class="font-weight-medium">Tele</span>
				<span class="font-weight-light">Retina</span>
			</router-link>
		</v-toolbar-title>
		<v-spacer></v-spacer>
		<v-toolbar-items>
			<!-- <v-btn color="primary" class="text-none mx-2" depressed @click="changeLang">{{ language }}</v-btn> -->
			<v-btn color="success" class="text-none mx-2" depressed @click="showModal">
				<template v-if="$vuetify.breakpoint.mdAndUp">{{ login_label }}</template>
				<template v-else>
					<v-icon color="white">mdi-login</v-icon>
				</template>
			</v-btn>
		</v-toolbar-items>

		<v-dialog v-model="modal" transition="dialog-transition" max-width="500">
			<v-card>
				<v-card-text class="pa-4">
					<v-form v-model="valid">
						<v-row class="text-center" dense>
							<v-col cols="12">
								<v-text-field
									v-model="email"
									label="Email / National ID"
									:rules="[rules.required, rules.emailOrNationalId]"
									@keydown.enter="login"
								></v-text-field>
							</v-col>

							<v-col cols="12">
								<v-text-field
									v-model="password"
									label="Password"
									:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
									:type="showPassword ? 'password' : 'text'"
									:rules="[rules.required, rules.password]"
									@click:append="() => (showPassword = !showPassword)"
									@keydown.enter="login"
								></v-text-field>
							</v-col>

							<v-col v-if="showLoginError" cols="12">
								<v-alert type="error" :value="true">Your login attempt failed</v-alert>
							</v-col>

							<v-col cols="12">
								<v-btn
									color="success"
									class="text-none"
									:disabled="!valid"
									:loading="attempting"
									@click="login"
								>
									<template>Login</template>
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-app-bar>

	<app-toolbar v-else></app-toolbar>
</template>

<script>
const axios = require("axios");
import AppToolbar from "@/components/_general/AppToolbar";

export default {
	components: {
		AppToolbar: AppToolbar
	},
	mixins: [
		require("@/mixins/backend-mixin").default,
		require("@/mixins/rules-mixin").default
	],
	data() {
		return {
			language: "عربي",
			login_label: "Login",

			modal: false,
			email: "",
			password: "",
			showPassword: true,
			showLoginError: false,
			valid: false,
			attempting: false
		};
	},
	computed: {
		loggedIn() {
			return this.$store.state.loggedIn;
		},
		arabic() {
			return this.$store.state.arabic;
		}
	},
	watch: {
		arabic: {
			handler: function(newVal) {
				if (newVal) {
					this.$vuetify.rtl = true;
					this.language = "English";
					this.login_label = "تسجيل الدخول";
				} else {
					this.$vuetify.rtl = false;
					this.language = "عربي";
					this.login_label = "Login";
				}
			},
			immediate: true
		}
	},
	created() {
		this.checkIfLoggedin();
	},
	methods: {
		async checkIfLoggedin() {
			var userInfo = await this.getUser();
			if (userInfo && userInfo.UserType) {
				this.$store.dispatch("setUserInfo", userInfo);
			}
		},
		changeLang() {
			if (this.$vuetify.rtl) {
				this.$router.push("/");
			} else {
				this.$router.push("/ar");
			}
		},
		showModal() {
			this.attempting = false;
			this.showLoginError = false;
			this.modal = true;
		},
		async login() {
			if (!this.valid) {
				return;
			}

			this.showLoginError = false;
			this.attempting = true;

			const url = this.BACKEND_URL + "/api/auth/login";

			var data = new FormData();

			if(this.email.indexOf("@") != -1){
				data.append("email", this.email);
			} else {
				data.append("nationalId", this.email);
			}

			data.append("password", this.password);

			let thisVue = this;

			let config = {};

			await axios
				.post(url, data, config)
				.then(async response => {
					if (response.data == false) {
						// TODO
						// should respond with error in backend
						throw "Error";
					}
					this.setBackendToken(response.data.access_token);
					var userInfo = await this.getUser();
					this.$store.dispatch("setUserInfo", userInfo);
					this.modal = false;
					this.goToUserHome(userInfo.UserType);
				})
				.catch(error => {
					thisVue.showLoginError = true;
					this.attempting = false;
					console.log("ERRRROR");
					console.error(error);
				});
		},
		goToUserHome(type) {
			// TODO
			// Refactor and centeralize
			console.log(type);
			if (type == 1) {
				this.$router.push("/dashboard/home");
			} else if (type == 2) {
				this.$router.push("/dashboard/home");
			} else if (type == 3) {
				this.$router.push("/new-appointment");
			} else if (type == 4) {
				this.$router.push("/new-appointment");
			} else if (type == 5) {
				this.$router.push("/new-appointment");
			} else if (type == 6) {
				this.$router.push("/new-appointment");
			} else {
				this.$router.push("/");
			}
		}
	}
};
</script>